export enum ROLE_TYPES {
  'ROLE_USER' = 'bo_user',
  'ROLE_ADMIN' = 'co_admin',
  'ROLE_MANAGER' = 'manager'
}
